import React from "react";

import { templates } from "@reactivated";

import { OrderCancelButton } from "../apps/customer-account/OrderCancelButton";

export const Template = (
    props: templates.OrderCancelButtonTemplate,
): React.JSX.Element => {
    return <OrderCancelButton {...props} />;
};
